import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    talentDetailsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    talentDetail: {},
    talentDetail__name: {
      fontWeight: 500,
      fontSize: 25,
    },
    talentDetail__location: {
      fontSize: 16,
      color: '#6e767f',
      lineHeight: 1,
    },
    talentDetail__title: {
      fontSize: 16,
      color: '#6e767f',
    },
    talentDetail__content: {
      fontSize: 16,
      color: theme.palette.type === 'dark' ? theme.palette.customGrey.dark : theme.palette.customGrey.dark,
    },
    talentDetail__statistics: {
      marginTop: 4,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexWrap: 'wrap',
    },
    talentDetail__statistics__value: {
      display: 'flex',
      gap: 4,
    },
    talentDetail__statistics__separator: {
      fontSize: 18,
      color: '#6e767f',
    },
    logoContainer: {
      height: 100,
      [theme.breakpoints.down(420)]: {
        width: '100%',
        marginTop: 10,
      },
      [theme.breakpoints.up(421)]: {
        width: 177.78,
      },
    },
    logo: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'top center',
    },
  }),
);
